import { store } from "../store";
import { getWidgetConfig } from "../reducers/methods";
import { StoreState } from "../reducers/";
import { sendElementResized } from "../actions";
import { Action } from "redux";

export function isEditMode(): boolean {
  const state = store.getState() as StoreState;
  const config = getWidgetConfig(state);

  return config && config.__editMode__;
}

export function sendResizeToMerchant(
  event: MouseEvent,
  configName: string,
  newStyle: {
    left: string;
    top: string;
    width: string;
    height: string;
  }
): boolean {
  if (isEditMode()) {
    event.stopPropagation();
    event.preventDefault();

    store.dispatch(sendElementResized(event, configName, newStyle) as Action);

    return true;
  }

  return false;
}
